const cx = function cx() {
  const result = Array.prototype.slice.call(arguments).filter(Boolean).join(' ');
  return result;
};

export default cx;
//# sourceMappingURL=cx.js.map